import { render, staticRenderFns } from "./u-tabs-dot.vue?vue&type=template&id=3e7988fe&scoped=true&"
import script from "./u-tabs-dot.vue?vue&type=script&lang=js&"
export * from "./u-tabs-dot.vue?vue&type=script&lang=js&"
import style0 from "./u-tabs-dot.vue?vue&type=style&index=0&id=3e7988fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e7988fe",
  null
  
)

export default component.exports